import ACTIONS from "../../constants/actions";
import Xhr from "../../helpers/Xhr";

export const getPopulars = (period) => dispatch => {
	Xhr.getPopulars(period).then((resp) => {
		dispatch({
			type : ACTIONS.LINE.GET_POPULAR,
			data : resp ? resp.data : [],
		})
	});
};

export const getLineWidget = (period) => dispatch => {
	Xhr.getLine(period).then((resp) => {
		dispatch({
			type : ACTIONS.LINE.GET_LINE,
			data : resp ? resp.data : [],
		})
	});
};





// WEBPACK FOOTER //
// ./src/app/redux/actions/line.js